(() => {
  const config = document.currentScript?.dataset;
  const location = new URL(window.location.href);
  const theme = window.Shopify?.theme;
  if (!config || !/\.myshopify\.com$/i.test(location.hostname) || location.protocol !== 'https:') return;
  if (!/^\d+$/.test(config.themeId || '') || String(theme?.id) !== config.themeId || theme?.role !== 'unpublished') return;
  if (location.searchParams.get('_ab') !== '0' || location.searchParams.get('_fd') !== '0' || location.searchParams.get('_sc') !== '1') return;
  if (location.searchParams.has('preview_theme_id') && location.searchParams.get('preview_theme_id') !== config.themeId) return;
  if (window.DomaPreviewNavigation) return;

  let primaryOrigin;
  try { primaryOrigin = new URL(config.primaryOrigin).origin; } catch { return; }
  const allowedPath = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?(?:\/(?:products|collections|pages|blogs|policies)(?:\/|$)|\/search\/?$|\/cart\/?$|\/$)/i;

  function preserveURL(raw) {
    if (typeof raw !== 'string' || !raw || raw.startsWith('#')) return raw;
    let url;
    try { url = new URL(raw, window.location.href); } catch { return raw; }
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return raw;
    if (url.origin !== location.origin && url.origin !== primaryOrigin) return raw;
    if (!allowedPath.test(url.pathname)) return raw;
    const result = new URL(url.pathname + url.search + url.hash, location.origin);
    for (const key of ['preview_token', '_cd', '_uid']) result.searchParams.delete(key);
    result.searchParams.set('_ab', '0');
    result.searchParams.set('_fd', '0');
    result.searchParams.set('_sc', '1');
    result.searchParams.set('preview_theme_id', config.themeId);
    return result.href;
  }

  function rewriteLink(link) {
    if (!link || link.hasAttribute('download')) return;
    const original = link.getAttribute('href');
    const updated = preserveURL(original);
    if (updated !== original) link.setAttribute('href', updated);
  }

  function prepareTree(root) {
    if (root.matches?.('a[href]')) rewriteLink(root);
    root.querySelectorAll?.('a[href]').forEach(rewriteLink);
  }

  function prepareForm(form) {
    if (!form || form.tagName !== 'FORM') return;
    const original = form.getAttribute('action') || window.location.pathname;
    const updated = preserveURL(original);
    let url;
    try { url = new URL(updated); } catch { return; }
    if (url.origin !== location.origin || url.searchParams.get('preview_theme_id') !== config.themeId ||
      url.searchParams.get('_ab') !== '0' || url.searchParams.get('_fd') !== '0' || url.searchParams.get('_sc') !== '1') return;
    const method = (form.getAttribute('method') || 'get').toLowerCase();
    if (method === 'get' && /\/search\/?$/.test(url.pathname)) {
      for (const key of ['_ab', '_fd', '_sc', 'preview_theme_id']) {
        let input = form.querySelector('input[name="' + key + '"]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = key; form.append(input); }
        input.value = url.searchParams.get(key);
      }
      form.setAttribute('action', url.origin + url.pathname);
    } else if (method === 'post' && /\/cart\/?$/.test(url.pathname)) {
      form.setAttribute('action', updated);
    }
  }

  window.DomaPreviewNavigation = Object.freeze({ preserveURL });
  if (window.routes?.cart_url) window.routes.cart_url = preserveURL(window.routes.cart_url);
  document.addEventListener('click', event => rewriteLink(event.target?.closest?.('a[href]')), true);
  document.addEventListener('auxclick', event => rewriteLink(event.target?.closest?.('a[href]')), true);
  document.addEventListener('submit', event => prepareForm(event.target), true);
  function start() {
    prepareTree(document);
    const observer = new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) prepareTree(node);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
